var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerticalDotsIcon = function SvgVerticalDotsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeWidth: 1.5,
    d: "M10 19.5c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2ZM10 5.5c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeWidth: 1.5,
    d: "M10 12.5c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Z",
    opacity: 0.4
  })));
};
export default SvgVerticalDotsIcon;